import { createContext, FC, useContext, useEffect, useState } from 'react'
import { ArticleView } from 'types'
import { useQueryParams } from 'hooks/useQueryParams'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useRouteMatch } from 'react-router-dom'
import { DOC_PATH, FOLDER_DOC_PATH } from 'paths'

interface IArticleViewContext {
  articleView: ArticleView | null
}

export const ArticleViewContext = createContext<IArticleViewContext>({
  articleView: null,
})

export const ArticleViewProvider: FC<React.PropsWithChildren<unknown>> = observer(({ children }) => {
  const { isDesktop } = useResponsiveDesign()
  const { docView: currentArticleView } = useQueryParams()
  const rootStore = useRootStore()
  const [articleView, setArticleView] = useState(null)
  const isInDoc = useRouteMatch(DOC_PATH) || useRouteMatch(FOLDER_DOC_PATH)

  useEffect(() => {
    if (currentArticleView) {
      setArticleView(currentArticleView)
    }
  }, [currentArticleView])

  useEffect(() => {
    if (articleView) {
      rootStore.docStore?.setArticleView(articleView)
    }
  }, [articleView, rootStore.docStore])

  useEffect(() => {
    if (!articleView || articleView === ArticleView.Reading) {
      rootStore.layout.setRightColumnLocked(false)
    }

    if (articleView && articleView !== ArticleView.Reading && isDesktop && isInDoc) {
      rootStore.layout.setRightColumnLocked(true)
    }
  }, [articleView, rootStore.layout, isDesktop, isInDoc])

  return <ArticleViewContext.Provider value={{ articleView }}>{children}</ArticleViewContext.Provider>
})

export const useArticleView = () => {
  const { articleView } = useContext(ArticleViewContext)
  return articleView
}
